import { InterviewService } from "../../../services/InterviewService";
import InterviewListPage from "./InterviewList";

export default function InterviewListTabPane() {
  function getInterviews(pageSize, pageNumber, searchObject) {
    return InterviewService.getInterview(pageSize, pageNumber, searchObject);
  }
  return <InterviewListPage getInterviews={getInterviews} />;
}
